const KKM_TYPE_MANUAL = 0;

const KKM_TYPES = [
  { text: 'Ручная', value: KKM_TYPE_MANUAL },
  { text: 'КМ100-7.1', value: 1 },
  { text: 'КМ100-7.3', value: 2 },
  { text: 'КМ100-7.5', value: 3 },
  { text: 'ККМ100s2', value: 4 },
  { text: 'ККМ105', value: 5 },
  { text: 'ККМ108', value: 6 },
  { text: 'КМГ-100', value: 7 },
];

const KKM_TYPE_TABLE_COUNT = {
  0: 8,
  1: 1,
  2: 3,
  3: 5,
  4: 2,
  5: 5,
  6: 8,
  7: 1,
};

const MATRIX_COLS = Array.from({ length: 10 }, (_, i) => `D${i}`);
const MATRIX_ROWS = Array.from({ length: 10 }, (_, i) => `E${i}`);

const HUNDRED_KEYS = Array.from({ length: 8 }, (_, i) => `hundred${i + 1}`);

/** Цифровая таблица: 15 столбцов × 17 строк = 255 */
const DIGIT_HANDSET_COLS = 15;
const DIGIT_HANDSET_ROWS = 17;
const DIGIT_HANDSET_SIZE = DIGIT_HANDSET_COLS * DIGIT_HANDSET_ROWS;

function createEmptyHundred () {
  return Array(100).fill(0);
}

function getCellIndex (col, row) {
  return row * 10 + col;
}

/**
 * Значение ячейки таблицы сотни (E — строка, D — столбец).
 *
 * Старт квартир S = firstLocationId, смещение = S - 1, сотня h = hundredIndex (1..8).
 *
 * Строка E0: D0 = h×100 + смещение.
 *   S=1: D1..D9 = (h−1)×100 + c×10 (10, 20, 30 …).
 *   S>1: D1 = (h−1)×100 + 10 + смещение, далее +1 (S=2 → 101, 11, 12; S=3 → 102, 12, 13).
 *   Пример h=2,S=1: D0=200, D1=110, D2=120 …
 *
 * Строки E1..E9: Dc = (h−1)×100 + c×10 + номер_строки + смещение.
 *   В D0: E1=1, E2=2 …; во 2-й сотне: E1=101, E2=102 …
 */
function getHundredCellValue (hundredIndex, col, row, startLocationId = 1) {
  const h = Number(hundredIndex) || 1;
  const offset = Math.max(0, Number(startLocationId) - 1) || 0;
  const base = (h - 1) * 100;

  if (row === 0) {
    if (col === 0) {
      return h * 100 + offset;
    }
    if (offset === 0) {
      return base + col * 10;
    }
    return base + 10 + (col - 1) + offset;
  }

  return base + col * 10 + row + offset;
}

function fillHundredTable (hundredIndex, startLocationId = 1) {
  const table = createEmptyHundred();

  for (let row = 0; row < 10; row += 1) {
    for (let col = 0; col < 10; col += 1) {
      table[getCellIndex(col, row)] = getHundredCellValue(
        hundredIndex,
        col,
        row,
        startLocationId,
      );
    }
  }

  return table;
}

function createEmptyHundreds () {
  return HUNDRED_KEYS.reduce((acc, key) => {
    acc[key] = createEmptyHundred();
    return acc;
  }, {});
}

function getVisibleHundredKeys (kkmtype) {
  const count = KKM_TYPE_TABLE_COUNT[kkmtype] ?? 0;
  return HUNDRED_KEYS.slice(0, count);
}

function hundredsForKkmtype (source, kkmtype) {
  const result = createEmptyHundreds();
  getVisibleHundredKeys(kkmtype).forEach((key) => {
    if (Array.isArray(source?.[key]) && source[key].length === 100) {
      result[key] = [...source[key]];
    }
  });
  return result;
}

function createEmptyDigitHandset () {
  return Array(DIGIT_HANDSET_SIZE).fill(0);
}

/** Column-major: сверху вниз по столбцам (1,2,3… затем следующий столбец). */
function getDigitHandsetIndex (col, row) {
  return col * DIGIT_HANDSET_ROWS + row;
}

/** Заполнение 1…255 сверху вниз по столбцам (независимо от старта квартир). */
function fillDigitHandset (/* startLocationId */) {
  const table = createEmptyDigitHandset();

  for (let col = 0; col < DIGIT_HANDSET_COLS; col += 1) {
    for (let row = 0; row < DIGIT_HANDSET_ROWS; row += 1) {
      const idx = getDigitHandsetIndex(col, row);
      table[idx] = idx + 1;
    }
  }

  return table;
}

function normalizeDigitHandset (source) {
  if (!Array.isArray(source) || source.length !== DIGIT_HANDSET_SIZE) {
    return createEmptyDigitHandset();
  }
  return source.map((v) => {
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  });
}

function isDigitHandsetEmpty (table) {
  return !Array.isArray(table) || table.every((v) => Number(v) === 0);
}

export {
  KKM_TYPE_MANUAL,
  KKM_TYPES,
  KKM_TYPE_TABLE_COUNT,
  MATRIX_COLS,
  MATRIX_ROWS,
  HUNDRED_KEYS,
  DIGIT_HANDSET_COLS,
  DIGIT_HANDSET_ROWS,
  DIGIT_HANDSET_SIZE,
  createEmptyHundred,
  createEmptyHundreds,
  getCellIndex,
  fillHundredTable,
  getHundredCellValue,
  getVisibleHundredKeys,
  hundredsForKkmtype,
  createEmptyDigitHandset,
  getDigitHandsetIndex,
  fillDigitHandset,
  normalizeDigitHandset,
  isDigitHandsetEmpty,
};
